import { collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '@/lib/firebase'

export interface JobListing {
  id: string
  title: string
  company: string
  location: string
  description: string
  requirements: string[]
  employerId: string
  pay?: string
  jobType?: string
  hours?: string
  salary?: { min: number; max: number; currency: string }
  tags: string[]
  applyUrl?: string
  ra7277Compliant: boolean
  status: 'active' | 'delisted' | 'closed'
  createdAt: number
  updatedAt: number
}

export interface Provider {
  id: string
  name: string
  category: string
  address: string
  description: string
  ownerId: string
  phone?: string
  email?: string
  website?: string
  rate?: string
  accessibilityTags: string[]
  pwdDiscount: boolean
  ra7277Compliant: boolean
  beaconQrEnabled: boolean
  status: 'active' | 'delisted'
  createdAt: number
  updatedAt: number
}

export interface GovProgram {
  id: string
  icon: string
  name: string
  amount: string
  description: string
  phone: string
  region: string
  tags?: string[]
  createdAt: number
  updatedAt: number
}

export interface NgoProgram {
  id: string
  icon: string
  name: string
  amount: string
  description: string
  contact: string
  website?: string
  tags?: string[]
  createdAt: number
  updatedAt: number
}

export async function getJobs(filters?: { ra7277Only?: boolean }): Promise<JobListing[]> {
  const constraints: Parameters<typeof query>[1][] = [where('status', '==', 'active')]
  if (filters?.ra7277Only) constraints.push(where('ra7277Compliant', '==', true))
  const snap = await getDocs(query(collection(db, 'jobs'), ...constraints))
  return snap.docs.map((d) => ({ id: d.id, ...d.data() } as JobListing)).sort((a, b) => b.createdAt - a.createdAt)
}

export async function getProviders(filters?: { category?: string }): Promise<Provider[]> {
  const snap = await getDocs(query(collection(db, 'providers'), where('status', '==', 'active')))
  let results = snap.docs.map((d) => ({ id: d.id, ...d.data() } as Provider))
  if (filters?.category) results = results.filter((p) => p.category === filters.category)
  return results.sort((a, b) => b.createdAt - a.createdAt)
}

export async function getGovPrograms(): Promise<GovProgram[]> {
  const snap = await getDocs(collection(db, 'gov_aid_programs'))
  return snap.docs.map((d) => ({ id: d.id, ...d.data() } as GovProgram))
}

export async function getNgoPrograms(): Promise<NgoProgram[]> {
  const snap = await getDocs(collection(db, 'ngo_programs'))
  return snap.docs.map((d) => ({ id: d.id, ...d.data() } as NgoProgram))
}
